import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "mb-2 ml-2" };
const _hoisted_2 = { class: "fw-bold" };
const _hoisted_3 = { class: "mb-4 data-box__select cart_email-box" };
const _hoisted_4 = {
    key: 0,
    class: "item-full-width"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_text_field = _resolveComponent("g-text-field");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h6", _hoisted_2, _toDisplayString(_ctx.$tc('client.Commerce.Carts.EMailAddress')), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
            (_ctx.data.addresses?.invoice)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_g_text_field, {
                        placeholder: "E-Mail-Adresse",
                        label: "E-Mail-Adresse",
                        "data-member": "eMail",
                        "data-object": _ctx.data.addresses?.invoice,
                        mode: "email",
                        "data-mode": "model",
                        "validation-rules": { type: 'email' }
                    }, null, 8, ["data-object"])
                ]))
                : _createCommentVNode("", true)
        ])
    ], 64));
}
